import { isNull } from "lodash"
import { useTranslation } from "react-i18next"

import Dialog from "@/components/dialog/Dialog"
import BasicButton from "@/components/button/BasicButton"
import { useDeleteSessionTypeMutation } from "@/hooks/api/useTeamQuery"
import { createGlobalStore } from "@/stores/global"
import { useNativeBridge } from "@/hooks/useNativeBridge"

export default function RemoveConfirmDialog({
  removeDialogOpen,
  setRemoveDialogOpen,
  selectedIdfSessionType,
  setSelectedIdfSessionType,
}: {
  removeDialogOpen: boolean
  setRemoveDialogOpen: (open: boolean) => void
  selectedIdfSessionType: number | null
  setSelectedIdfSessionType: (idfSessionType: number | null) => void
}) {
  const { t } = useTranslation()

  const { mutateAsync } = useDeleteSessionTypeMutation()
  const setSnackBar = createGlobalStore((state) => state.setSnackBar)
  const { notifySettingChanged } = useNativeBridge()
  const onRemoveSessionType = async () => {
    if (isNull(selectedIdfSessionType)) {
      return
    }
    notifySettingChanged("sessionType", "saving")
    try {
      await mutateAsync(selectedIdfSessionType)
      onCloseRemoveDialog()
      setSnackBar({ message: t("messages.successDelete"), severity: "success", open: true })
      notifySettingChanged("sessionType", "delete")
    } catch (error) {
      notifySettingChanged("sessionType", "error")

      return error
    }
  }

  const onCloseRemoveDialog = () => {
    setRemoveDialogOpen(false)
    setSelectedIdfSessionType(null)
  }

  return (
    <Dialog
      title={t("confirm")}
      open={removeDialogOpen}
      onClose={onCloseRemoveDialog}
      maxWidth="400px"
      footer={
        <div className="SessionTypeConfirmFooterCont">
          <BasicButton type="default-outlined" size="md" onClick={onCloseRemoveDialog}>
            {t("button.cancel")}
          </BasicButton>
          <BasicButton type="danger-outlined" size="md" onClick={onRemoveSessionType}>
            {t("button.remove")}
          </BasicButton>
        </div>
      }>
      <p className="session-type-confirm-content">{t("messages.confirmDelete")}</p>
    </Dialog>
  )
}
